import React, { useEffect, useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { WebView } from 'react-native-webview';
import { useContent } from '@sart/content'
import AppConfig from './Configuration';
import { colors, adaptive } from '@sart/styles'
import client from '@sart/client'

const HostedPayment = ({ navigation, route }) => {
  const [link, setLink] = useState(null)
  const content = useContent()

  useEffect(() => {
    const basketRefId = route.params?.basketRefId
    const gatewayURL = route.params?.gatewayURL

    setLink(gatewayURL)

    const checkPaymentStatus = async () => {
      let order = await client.getOrders(basketRefId, AppConfig.pollingMaxRetries)
      order = await client.pollOrderForStatus(client.cache.customerId, order.orderId)
      if (!order || order.status === 'failed') {
        console.log('Order failed: ' + JSON.stringify(order, null, 2))
        // navigation.navigate('Checkout', { failedOrder: order })
      } else {
        console.log('Order maybe succeeded and is: ' + JSON.stringify(order, null, 2))
        // navigation.navigate('CheckoutProcessing', { order, productsPurchased })
      }
      // if (order && order.status === 'successful') {
      //   await client.loadBalancesAndInvoices()
      //   navigation.navigate('Confirmation', { productsPurchased, order })
      // } else if (order && order.status === 'failed') {
      //   setData({ loading: false, error: content.errors.failedPurchase })
      // }
    }

    checkPaymentStatus()
  }, [navigation, route])

  return (
    <View style={styles.container}>
      <WebView
        source={{ uri: link }}
        style={styles.webview}
        keyboardDisplayRequiresUserAction={false}
        hideKeyboardAccessoryView={true}
      />
      {/* <Space height={24} />
      <CompanyIcon width={220} height={181} color={colors.white}/>
      <Space height={2 * 24} />
      <Title style={styles.title}>
        {content.common.processing}
      </Title> */}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // backgroundColor: colors.srGreen,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 12
  },
  title: {
    color: colors.white,
    fontSize: 24
  },
  webview: {
    // marginTop: 10,
    maxHeight: 800,
    ...adaptive.webViewWidth,
    flex: 1
  }
})

export default HostedPayment
